// Libraries
import { useEffect, useState } from "react";
import { BrowserRouter, Link, Navigate, Route, Routes } from "react-router-dom";
// Components
import ThemeOne from "./components/theme-one/ThemeOne";
import ThemeTwoR from "./components/theme-two/ThemeTwoR";
import ThemeThree from "./components/theme-three/ThemeThree";
import RippleEffect from "./components/animation/RippleEffect";
import { ToastContainer } from "react-toastify";
import PaymentsPage, { PaymentCancelPage, PaymentStatusPage } from "./components/payments/PaymentsPage";
import DocumentChatPage from "./components/document-chat/DocumentChatPage";
// CSS
import "./styles/common.css";
import 'react-toastify/dist/ReactToastify.css';

function NotFoundPage() {
    return (
        <main className="flex min-h-screen items-center justify-center bg-primary_one-150 px-4 py-16 text-primary_one-50">
            <section className="w-full max-w-xl rounded-2xl border border-primary_one-100 bg-primary_one-140 p-10 text-center shadow-xl">
                <p className="mb-3 font-semibold uppercase tracking-[0.2em] text-primary_one-200">404</p>
                <h1 className="mb-4 text-[42px] font-bold max-md:text-[32px]">Page not found</h1>
                <p className="mb-8 text-gray-300">The page you requested does not exist or may have moved.</p>
                <Link
                    to="/"
                    className="inline-block rounded-md bg-primary_one-200 px-8 py-3 font-semibold uppercase tracking-wide text-white transition-colors hover:bg-red-700"
                >
                    Back to home
                </Link>
            </section>
        </main>
    );
}

function App() {
    const [visibleRipple, setVisibleRipple] = useState<boolean>(false);
    const [visibleRippleSend, setVisibleRippleSend] = useState<any>([]);
    const [position, setPosition] = useState<any>({ x: 0, y: 0 });

    /**
     * Ripple effect and position handling
     * */
    useEffect(() => {
        setVisibleRipple(visibleRippleSend.visible);
        setPosition({
            x: visibleRippleSend.x,
            y: visibleRippleSend.y
        });
    }, [visibleRippleSend]);

    return (
        <div>
        <RippleEffect visibleRipple={visibleRipple} position={position} />
        <ToastContainer />
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<ThemeOne setVisibleRipple={setVisibleRippleSend} />}></Route>
                <Route path="/theme-two" element={<ThemeTwoR setVisibleRipple={setVisibleRippleSend} />}></Route>
                <Route path="/theme-three" element={<ThemeThree />}></Route>
                <Route path="/payments" element={<PaymentsPage />}></Route>
                <Route path="/document-chat" element={<DocumentChatPage />}></Route>
                <Route path="/payment" element={<Navigate to="/payments" replace />}></Route>
                <Route path="/subscriptions" element={<Navigate to="/payments" replace />}></Route>
                <Route path="/payment/success" element={<PaymentStatusPage />}></Route>
                <Route path="/payment/cancel" element={<PaymentCancelPage />}></Route>
                <Route path="/subscription/success" element={<PaymentStatusPage />}></Route>
                <Route path="/subscription/cancel" element={<PaymentCancelPage />}></Route>
                <Route path="*" element={<NotFoundPage />}></Route>
            </Routes>
        </BrowserRouter>
    </div>
    );
}

export default App;
